export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11173.62367d76.jpg";